import React, {useEffect, useMemo, useState} from 'react';
import {handleActiveToast} from "../../../../components/sonner/ToastBasic";
import Search from "../../../../components/search/Search";
import {removeBulletinboards} from "../../../../api/bulletinboard/BulletinboardService";
import {BULLENTIN_BOARD_LIST_HEADER} from "../../../../components/table/header/Headers";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../api/user/UserAccountService";
import {initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";

function BulletinboardListType({checked, data, dataHook, type, pageInfo}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const [header, setHeader] = useState({order: BULLENTIN_BOARD_LIST_HEADER, exclude: []});

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, BULLENTIN_BOARD_LIST_HEADER, setHeader, [], () => {}, () => {}, 'bulletin_board');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "자료 상세"),
            url: `/settings/bulletinboard/${id}`,
        });
    };

    const deleteBulletinboard = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 내용을 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        try {
            const ids = rows.map((row) => row.id).filter((id) => id != null);
            const response = await removeBulletinboards({ids});
            if (response.status === 200) {
                handleActiveToast({message: "삭제되었습니다."});
                checked?.setChecked?.([]);
                refresh();
            } else {
                handleActiveToast({message: "삭제할 권한이 없습니다."});
            }
        } catch (error) {
            if (error.response?.status === 403) {
                handleActiveToast({message: "삭제할 권한이 없습니다."});
            } else {
                alert("서버와 연결할 수 없습니다. 잠시 후 다시 시도하세요.");
            }
        }
    };

    const bulletinboardJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const createUrl = type === "request" ? "/settings/bulletinboard/create/request" : "/settings/bulletinboard/create/main";

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={`bulletin_board_${type}`} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} searchBar={{placeHolder: '제목, 내용'}} size pageInfo={pageInfo} />

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={bulletinboardJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {bulletin_board: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'bulletin_board')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteBulletinboard}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                handleActiveToast({message: "삭제할 내용을 선택해주세요."});
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate(createUrl)}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export default BulletinboardListType;
